import React, { useState } from 'react';
import { Card, Form, Divider, Button, Typography, Spin, Row, Col } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import styles from './../styles.less';
import { CurrentPasswordModal } from '../../index';

const UserTwoFACard = ({ dispatch, loading, user }) => {
  const [openCurrentPasswordModalData, setOpenCurrentPasswordModalData] = useState(false);
  const isUserEnabled = !!user.two_factor_confirmed_at;
  const userName = `${user.first_name} ${user.last_name}`;

  const delete2FARequest = (currentPassword) => {
    dispatch({
      type: 'users/userDeleteOtherUserTwoFactor',
      payload: {
        id: user.id,
        current_password: currentPassword,
      },
    }).then((result) => {
      if (result.success) {
        setOpenCurrentPasswordModalData(null);
        dispatch({
          type: 'users/getUserInfo',
          payload: { id: user.id },
        });
      }
    });
  };

  return (
    <Card className={styles.noMarginTop}>
      <h3><FormattedMessage id="Component.2FA.Title" /></h3>
      <Typography.Paragraph><FormattedMessage id="Component.2FA.Description" /></Typography.Paragraph>
      <Divider />
      <h4><FormattedMessage id={`Component.2FA.User${isUserEnabled ? '' : 'Not'}EnabledText`} values={{ userName }} /></h4>
      <Typography.Paragraph><FormattedMessage id="Component.2FA.UserGoalDescription" values={{ userName }} /></Typography.Paragraph>

      {isUserEnabled && (
        <Spin
          spinning={!!loading.effects['users/userDeleteTwoFactor']}
        >
          <Row>
            <Col>
              <Button type="danger" onClick={() => setOpenCurrentPasswordModalData(true)}>
                <FormattedMessage id="Component.2FA.Disable" />
              </Button>
            </Col>
          </Row>
        </Spin>
      )}
      {!!openCurrentPasswordModalData && (
        <CurrentPasswordModal
          visible={!!openCurrentPasswordModalData}
          onCancel={() => setOpenCurrentPasswordModalData(null)}
          onSuccess={currentPassword => delete2FARequest(currentPassword)}
        />)}
    </Card>
  );
};

export default connect(
  ({ loading }) => ({ loading }))(Form.create()(injectIntl(UserTwoFACard)));



// WEBPACK FOOTER //
// ./src/components/UsersAdministration/UserTwoFACard/UserTwoFACard.js